<template>
    <div class="d-inline-block">
        <!-- Nút Xem chi tiết kích hoạt Dialog -->
        <v-btn small color="teal darken-4" dark @click="dialog = true">
            <v-icon small left>mdi-eye</v-icon> Xem
        </v-btn>

        <!-- Dialog Phiếu Lương V2 -->
        <v-dialog v-model="dialog" max-width="850px" scrollable>
            <v-card class="rounded-lg">
                <v-card-title class="teal darken-4 white--text py-3">
                    Chi tiết phiếu lương V2
                    <v-spacer></v-spacer>
                    <v-btn small color="amber darken-2" dark class="mr-2" @click="exportPDF">
                        <v-icon small left>mdi-download</v-icon> Tải PDF
                    </v-btn>
                    <v-btn small icon dark @click="dialog = false">
                        <v-icon>mdi-close</v-icon>
                    </v-btn>
                </v-card-title>

                <v-card-text class="pt-4 black--text" style="background-color: #fafafa;">
                    <div :id="'salary-slip-' + getValByIndex(1)" class="salary-slip-container pa-4 white elevation-1 rounded-lg">
                        <!-- Header Phiếu Lương -->
                        <div class="text-center mb-6">
                            <div class="headline font-weight-bold teal--text text--darken-4 text-uppercase">Phiếu Lương</div>
                            <div class="subtitle-1 font-weight-bold grey--text text--darken-2">Tháng {{ monthFormatted }}</div>
                        </div>

                        <!-- Thông tin nhân viên -->
                        <v-row class="mb-2">
                            <v-col cols="6" class="py-1">
                                <div class="d-flex"><span class="font-weight-bold mr-2 text-no-wrap" style="width: 180px; min-width: 180px; display: inline-block;">Họ và tên:</span> {{ getValByIndex(2) }}</div>
                                <div class="d-flex"><span class="font-weight-bold mr-2 text-no-wrap" style="width: 180px; min-width: 180px; display: inline-block;">Chi nhánh/Phòng ban:</span> {{ getValByIndex(4) }}</div>
                                <div class="d-flex"><span class="font-weight-bold mr-2 text-no-wrap" style="width: 180px; min-width: 180px; display: inline-block;">Chức vụ/Vị trí:</span> {{ getValByIndex(3) }}</div>
                                <div class="d-flex"><span class="font-weight-bold mr-2 text-no-wrap" style="width: 180px; min-width: 180px; display: inline-block;">Số tài khoản:</span> {{ getValByIndex(8) }}</div>
                            </v-col>
                            <v-col cols="6" class="py-1">
                                <div class="d-flex"><span class="font-weight-bold mr-2 text-no-wrap" style="width: 140px; min-width: 140px; display: inline-block;">MSNV:</span> {{ getValByIndex(1) }}</div>
                                <div class="d-flex"><span class="font-weight-bold mr-2 text-no-wrap" style="width: 140px; min-width: 140px; display: inline-block;">Bộ phận:</span> {{ getValByIndex(6) }}</div>
                                <div class="d-flex"><span class="font-weight-bold mr-2 text-no-wrap" style="width: 140px; min-width: 140px; display: inline-block;">Tại Ngân hàng:</span> {{ getValByIndex(7) }}</div>
                            </v-col>
                        </v-row>

                        <div class="red--text text--darken-3 font-italic caption mb-4">
                            *** Lưu ý: Vì tính bảo mật, mỗi cá nhân cam kết không tiết lộ thông tin tiền lương, nếu vi phạm sẽ bị xử lý theo quy định của Công ty.
                        </div>

                        <!-- Bảng Chi tiết 2 Cột -->
                        <v-row class="mb-4">
                            <!-- Cột bên trái: Chấm công & Khấu trừ -->
                            <v-col cols="6" class="pr-2 py-0">
                                <table class="salary-table w-100">
                                    <thead>
                                        <tr class="amber darken-2 white--text">
                                            <th colspan="2" class="text-left px-2 py-1">Chấm công</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        <tr>
                                            <td class="px-2 py-1">Ngày công chuẩn</td>
                                            <td class="text-right px-2 py-1 font-weight-bold">{{ getValByIndex(8) }}</td>
                                        </tr>
                                        <tr>
                                            <td class="px-2 py-1">Ngày công tính lương</td>
                                            <td class="text-right px-2 py-1 font-weight-bold">{{ getValByIndex(9) }}</td>
                                        </tr>
                                        <tr>
                                            <td class="px-2 py-1">Giờ làm thêm</td>
                                            <td class="text-right px-2 py-1 font-weight-bold">{{ getValByIndex(12) }}</td>
                                        </tr>
                                        <tr>
                                            <td class="px-2 py-1">Giờ tính tăng ca</td>
                                            <td class="text-right px-2 py-1 font-weight-bold">{{ getValByIndex(13) }}</td>
                                        </tr>
                                        <tr>
                                            <td class="px-2 py-1">Giờ Lễ/tết</td>
                                            <td class="text-right px-2 py-1 font-weight-bold">{{ getValByIndex(14) }}</td>
                                        </tr>

                                        <tr class="amber darken-2 white--text">
                                            <th colspan="2" class="text-left px-2 py-1">Các khoản khấu trừ</th>
                                        </tr>
                                        <tr>
                                            <td class="px-2 py-1">Tạm ứng cơm/Lương</td>
                                            <td class="text-right px-2 py-1">{{ getValByIndex(33) }}</td>
                                        </tr>
                                        <tr>
                                            <td class="px-2 py-1">BHXH (10.5%)</td>
                                            <td class="text-right px-2 py-1">{{ getValByIndex(34) }}</td>
                                        </tr>
                                        <tr>
                                            <td class="px-2 py-1">Thuế TNCN</td>
                                            <td class="text-right px-2 py-1">{{ getValByIndex(35) }}</td>
                                        </tr>
                                        <tr>
                                            <td class="px-2 py-1">Truy thu/ Thu hồi</td>
                                            <td class="text-right px-2 py-1">{{ getValByIndex(36) }}</td>
                                        </tr>
                                        <tr>
                                            <td class="px-2 py-1">Truy thu Thuế TNCN 2025 (QT thuế 2025)</td>
                                            <td class="text-right px-2 py-1">{{ getValByIndex(54) }}</td>
                                        </tr>

                                        <!-- Footer cột trái -->
                                        <tr class="grey lighten-4 red--text text--darken-3 font-weight-bold font-italic">
                                            <td class="px-2 py-1">Tổng Khấu trừ (1)</td>
                                            <td class="text-right px-2 py-1">{{ getValByIndex(56) }}</td>
                                        </tr>
                                    </tbody>
                                </table>
                            </v-col>

                            <!-- Cột bên phải: Thu nhập chuẩn & thực tế -->
                            <v-col cols="6" class="pl-2 py-0">
                                <table class="salary-table w-100">
                                    <thead>
                                        <tr class="amber darken-2 white--text">
                                            <th colspan="2" class="text-left px-2 py-1">Các khoản thu nhập chuẩn</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        <tr>
                                            <td class="px-2 py-1">Mức lương chính</td>
                                            <td class="text-right px-2 py-1">{{ getValByIndex(15) }}</td>
                                        </tr>
                                        <tr>
                                            <td class="px-2 py-1">Mức Phụ cấp công việc</td>
                                            <td class="text-right px-2 py-1">{{ getValByIndex(16) }}</td>
                                        </tr>
                                        <tr>
                                            <td class="px-2 py-1">Mức Phụ cấp trách nhiệm</td>
                                            <td class="text-right px-2 py-1">{{ getValByIndex(17) }}</td>
                                        </tr>
                                        <tr>
                                            <td class="px-2 py-1">Mức Hỗ trợ Điện thoại</td>
                                            <td class="text-right px-2 py-1">{{ getValByIndex(18) }}</td>
                                        </tr>
                                        <tr>
                                            <td class="px-2 py-1">Mức Hỗ trợ khoản công tác</td>
                                            <td class="text-right px-2 py-1">{{ getValByIndex(19) }}</td>
                                        </tr>

                                        <tr class="amber darken-2 white--text">
                                            <th colspan="2" class="text-left px-2 py-1">Các khoản thu nhập thực tế</th>
                                        </tr>
                                        <tr>
                                            <td class="px-2 py-1">Lương chính</td>
                                            <td class="text-right px-2 py-1 font-weight-bold">{{ getValByIndex(20) }}</td>
                                        </tr>
                                        <tr>
                                            <td class="px-2 py-1">Phụ cấp công việc</td>
                                            <td class="text-right px-2 py-1">{{ getValByIndex(21) }}</td>
                                        </tr>
                                        <tr>
                                            <td class="px-2 py-1">Phụ cấp trách nhiệm</td>
                                            <td class="text-right px-2 py-1">{{ getValByIndex(22) }}</td>
                                        </tr>
                                        <tr>
                                            <td class="px-2 py-1">Hỗ trợ Điện thoại</td>
                                            <td class="text-right px-2 py-1">{{ getValByIndex(23) }}</td>
                                        </tr>
                                        <tr>
                                            <td class="px-2 py-1">Hỗ trợ khoản công tác</td>
                                            <td class="text-right px-2 py-1">{{ getValByIndex(24) }}</td>
                                        </tr>
                                        <tr>
                                            <td class="px-2 py-1">Lương làm thêm</td>
                                            <td class="text-right px-2 py-1">{{ getValByIndex(25) }}</td>
                                        </tr>
                                        <tr>
                                            <td class="px-2 py-1">Lương tăng ca</td>
                                            <td class="text-right px-2 py-1">{{ getValByIndex(26) }}</td>
                                        </tr>
                                        <tr>
                                            <td class="px-2 py-1">Lương Lễ/tết</td>
                                            <td class="text-right px-2 py-1">{{ getValByIndex(27) }}</td>
                                        </tr>
                                        <tr>
                                            <td class="px-2 py-1">Hỗ trợ đào tạo</td>
                                            <td class="text-right px-2 py-1">{{ getValByIndex(29) }}</td>
                                        </tr>
                                        <tr>
                                            <td class="px-2 py-1">Hỗ trợ đi lại</td>
                                            <td class="text-right px-2 py-1">{{ getValByIndex(30) }}</td>
                                        </tr>
                                        <tr>
                                            <td class="px-2 py-1">Hỗ trợ nhà ở</td>
                                            <td class="text-right px-2 py-1">{{ getValByIndex(31) }}</td>
                                        </tr>
                                        <tr>
                                            <td class="px-2 py-1">Hỗ trợ xăng xe</td>
                                            <td class="text-right px-2 py-1">{{ getValByIndex(32) }}</td>
                                        </tr>
                                        <tr>
                                            <td class="px-2 py-1">Tiền ăn giữa ca</td>
                                            <td class="text-right px-2 py-1">{{ getValByIndex(28) }}</td>
                                        </tr>
                                        <tr>
                                            <td class="px-2 py-1">Truy lãnh/hoàn trả</td>
                                            <td class="text-right px-2 py-1">{{ getValByIndex(38) }}</td>
                                        </tr>
                                        <tr>
                                            <td class="px-2 py-1">Tổng thưởng</td>
                                            <td class="text-right px-2 py-1 font-weight-bold">{{ getValByIndex(51) }}</td>
                                        </tr>
                                        <tr>
                                            <td class="px-2 py-1">Phép năm hoàn lại</td>
                                            <td class="text-right px-2 py-1">{{ getValByIndex(41) }}</td>
                                        </tr>
                                        <tr>
                                            <td class="px-2 py-1">Trợ cấp thôi việc/ mất việc</td>
                                            <td class="text-right px-2 py-1">{{ getValByIndex(40) }}</td>
                                        </tr>
                                        <tr>
                                            <td class="px-2 py-1">Thưởng lương Tháng 13</td>
                                            <td class="text-right px-2 py-1">{{ getValByIndex(47) }}</td>
                                        </tr>
                                        <tr>
                                            <td class="px-2 py-1">Hoàn thuế TNCN 2025 (QT thuế 2025)</td>
                                            <td class="text-right px-2 py-1">{{ getValByIndex(53) }}</td>
                                        </tr>

                                        <!-- Footer cột phải -->
                                        <tr class="grey lighten-4 red--text text--darken-3 font-weight-bold font-italic">
                                            <td class="px-2 py-1">Tổng thu nhập (2)</td>
                                            <td class="text-right px-2 py-1">{{ getValByIndex(55) }}</td>
                                        </tr>
                                    </tbody>
                                </table>
                            </v-col>
                        </v-row>

                        <!-- Lương thực nhận -->
                        <div class="blue-box pa-3 rounded mb-4">
                            <div class="d-flex justify-space-between align-center">
                                <span class="title font-weight-bold blue--text text--darken-3">Lương thực nhận (2)-(1):</span>
                                <span class="headline font-weight-bold blue--text text--darken-3">{{ getValByIndex(57) }}</span>
                            </div>
                            <div class="caption font-weight-bold grey--text text--darken-3 mt-1">
                                Bằng chữ: <span class="font-italic">{{ netSalaryInWords }}</span>
                            </div>
                        </div>

                        <!-- Chú thích -->
                        <div class="caption mb-4" v-if="getValByIndex(37) || getValByIndex(39)">
                            <div v-if="getValByIndex(37)">(*) {{ getValByIndex(37) }}</div>
                            <div v-if="getValByIndex(39)">(**) {{ getValByIndex(39) }}</div>
                        </div>

                        <!-- Bảng phụ 1: Chi tiết Thưởng bán hàng -->
                        <div class="mb-4" v-if="hasBonusDetails">
                            <div class="subtitle-1 font-weight-bold red--text text--darken-3 text-center mb-2">
                                Chi tiết Thưởng bán hàng Tháng {{ monthFormatted }}
                            </div>
                            <table class="salary-table w-100">
                                <thead class="grey lighten-3 font-weight-bold">
                                    <tr>
                                        <th class="text-left px-2 py-1">Các khoản thưởng</th>
                                        <th class="text-right px-2 py-1" style="width: 180px;">Số tiền thưởng</th>
                                        <th class="text-left px-2 py-1" style="width: 250px;">Ghi chú</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    <tr>
                                        <td class="px-2 py-1">Thưởng Doanh thu</td>
                                        <td class="text-right px-2 py-1">{{ getValByIndex(42) }}</td>
                                        <td class="px-2 py-1"></td>
                                    </tr>
                                    <tr>
                                        <td class="px-2 py-1">Thưởng GP</td>
                                        <td class="text-right px-2 py-1">{{ getValByIndex(44) }}</td>
                                        <td class="px-2 py-1"></td>
                                    </tr>
                                    <tr>
                                        <td class="px-2 py-1">Thưởng đơn hàng online</td>
                                        <td class="text-right px-2 py-1">{{ getValByIndex(43) }}</td>
                                        <td class="px-2 py-1"></td>
                                    </tr>
                                    <tr>
                                        <td class="px-2 py-1">Thưởng chuyên môn</td>
                                        <td class="text-right px-2 py-1">{{ getValByIndex(48) }}</td>
                                        <td class="px-2 py-1"></td>
                                    </tr>
                                    <tr>
                                        <td class="px-2 py-1">Thưởng khác</td>
                                        <td class="text-right px-2 py-1">{{ getValByIndex(49) }}</td>
                                        <td class="px-2 py-1"></td>
                                    </tr>
                                    <tr class="grey lighten-4 font-weight-bold font-italic">
                                        <td class="px-2 py-1">Tổng các khoản thưởng</td>
                                        <td class="text-right px-2 py-1">{{ getValByIndex(51) }}</td>
                                        <td class="px-2 py-1"></td>
                                    </tr>
                                </tbody>
                            </table>
                        </div>

                        <!-- Bảng phụ 2: Chi tiết Thưởng lương Tháng 13 -->
                        <div v-if="hasMonth13Details" class="mt-4">
                            <div class="subtitle-1 font-weight-bold amber--text text--darken-4 mb-2 pa-1 yellow lighten-4 rounded">
                                Chi tiết Thưởng lương Tháng 13 năm 2025
                            </div>
                            <table class="salary-table w-100">
                                <tbody>
                                    <tr>
                                        <td class="px-2 py-1 font-weight-bold">Trung bình lương năm 2025</td>
                                        <td class="text-right px-2 py-1 font-weight-bold" style="width: 180px;">{{ getValByIndex(45) }}</td>
                                    </tr>
                                    <tr>
                                        <td class="px-2 py-1 font-weight-bold">Số tháng làm việc thực tế</td>
                                        <td class="text-right px-2 py-1 font-weight-bold">{{ getValByIndex(46) }}</td>
                                    </tr>
                                    <tr class="yellow lighten-4 font-weight-bold">
                                        <td class="px-2 py-1">Thưởng lương Tháng 13 năm 2025</td>
                                        <td class="text-right px-2 py-1 red--text">{{ getValByIndex(47) }}</td>
                                    </tr>
                                </tbody>
                            </table>
                        </div>
                    </div>
                </v-card-text>
            </v-card>
        </v-dialog>
    </div>
</template>

<script>
import moment from 'moment';

export default {
    name: "DetailV2",
    props: {
        item: {
            type: Object,
            required: true
        },
        indexToLabelMap: {
            type: Object,
            required: true
        },
        month: {
            type: String,
            required: true
        }
    },
    data() {
        return {
            dialog: false
        };
    },
    computed: {
        monthFormatted() {
            if (!this.month) return '';
            return moment(this.month, "YYYY-MM").format("MM.YYYY");
        },
        hasBonusDetails() {
            if (!this.item) return false;
            return !!(
                this.getValByIndex(42) ||
                this.getValByIndex(44) ||
                this.getValByIndex(43) ||
                this.getValByIndex(48) ||
                this.getValByIndex(49)
            );
        },
        hasMonth13Details() {
            if (!this.item) return false;
            return !!(
                this.getValByIndex(45) ||
                this.getValByIndex(46) ||
                this.getValByIndex(47)
            );
        },
        netSalaryInWords() {
            const rawVal = this.getValByIndex(57);
            if (!rawVal) return '';
            const rawStr = String(rawVal).replace(/,/g, '');
            const netSalary = parseFloat(rawStr);
            if (isNaN(netSalary)) return '';
            return this.convertNumberToWords(netSalary);
        }
    },
    methods: {
        getValByIndex(index) {
            if (!this.item || !this.indexToLabelMap) return '';
            const label = this.indexToLabelMap[index];
            if (!label) return '';
            return this.item[label] !== undefined && this.item[label] !== null ? this.item[label] : '';
        },
        convertNumberToWords(number) {
            if (number === 0) return "Không đồng";
            
            const units = ["", "một", "hai", "ba", "bốn", "năm", "sáu", "bảy", "tám", "chín"];
            const classes = ["", "nghìn", "triệu", "tỷ", "nghìn tỷ", "triệu tỷ"];
            
            function readThreeDigits(n, showZeroHundreds) {
                let hundreds = Math.floor(n / 100);
                let tens = Math.floor((n % 100) / 10);
                let ones = n % 10;
                let res = "";
                
                if (hundreds > 0 || showZeroHundreds) {
                    res += units[hundreds] + " trăm ";
                }
                
                if (tens > 1) {
                    res += units[tens] + " mươi ";
                } else if (tens === 1) {
                    res += "mười ";
                } else if (tens === 0 && ones > 0 && (hundreds > 0 || showZeroHundreds)) {
                    res += "lẻ ";
                }
                
                if (ones === 1 && tens > 1) {
                    res += "mốt";
                } else if (ones === 5 && tens > 0) {
                    res += "lăm";
                } else if (ones > 0) {
                    res += units[ones];
                }
                
                return res.trim();
            }

            let strNumber = Math.abs(Math.round(number)).toString();
            let groups = [];
            while (strNumber.length > 0) {
                groups.push(strNumber.substring(Math.max(0, strNumber.length - 3)));
                strNumber = strNumber.substring(0, Math.max(0, strNumber.length - 3));
            }
            
            let wordGroups = [];
            for (let i = 0; i < groups.length; i++) {
                let n = parseInt(groups[i]);
                if (n === 0 && groups.length > 1) {
                    wordGroups.push("");
                    continue;
                }
                let showZeroHundreds = i < groups.length - 1;
                let groupWord = readThreeDigits(n, showZeroHundreds);
                if (groupWord) {
                    wordGroups.push(groupWord + " " + classes[i]);
                } else {
                    wordGroups.push("");
                }
            }
            
            let result = wordGroups.reverse().filter(x => x !== "").join(" ").trim();
            result = result.charAt(0).toUpperCase() + result.slice(1) + " đồng chẵn";
            return result.replace(/\s+/g, ' ').trim();
        },
        exportPDF() {
            const employeeId = this.getValByIndex(1);
            const element = document.getElementById('salary-slip-' + employeeId);
            if (!element) {
                console.error("Salary slip element not found for ID:", employeeId);
                return;
            }

            const w = window.open('', '_blank');
            if (!w) {
                alert("Không thể mở cửa sổ in. Vui lòng cho phép trình duyệt hiển thị popup để tiếp tục!");
                return;
            }

            // Ghi nội dung phiếu lương kèm CSS in ấn chuẩn A4
            w.document.write(`
                <html>
                    <head>
                        <title>Phiếu Lương - Tháng ${this.monthFormatted}</title>
                        <style>
                            body {
                                margin: 0;
                                padding: 20px;
                                font-family: 'Segoe UI', Roboto, Helvetica, Arial, sans-serif;
                                background: white;
                            }
                            .salary-slip-container {
                                width: 100%;
                                max-width: 800px;
                                margin: 0 auto;
                                padding: 20px;
                                border: 1px solid #e0e0e0;
                                box-shadow: none !important;
                            }
                            .salary-table {
                                width: 100%;
                                border-collapse: collapse;
                                margin-bottom: 8px;
                                font-size: 11px;
                            }
                            .salary-table th, .salary-table td {
                                border: 1px solid #d0d0d0;
                                padding: 6px 8px;
                                line-height: 1.2;
                            }
                            .salary-table th {
                                background-color: #d97706 !important;
                                color: white !important;
                                -webkit-print-color-adjust: exact;
                                print-color-adjust: exact;
                                font-weight: bold;
                            }
                            .grey.lighten-4 {
                                background-color: #f5f5f5 !important;
                                -webkit-print-color-adjust: exact;
                                print-color-adjust: exact;
                            }
                            .yellow.lighten-4 {
                                background-color: #fef3c7 !important;
                                -webkit-print-color-adjust: exact;
                                print-color-adjust: exact;
                            }
                            .blue-box {
                                border: 1px solid #b3d7ff;
                                background-color: #f0f7ff !important;
                                padding: 12px;
                                border-radius: 4px;
                                margin-top: 10px;
                                margin-bottom: 10px;
                                -webkit-print-color-adjust: exact;
                                print-color-adjust: exact;
                            }
                            .d-flex { display: flex; }
                            .justify-space-between { justify-content: space-between; }
                            .align-center { align-items: center; }
                            .text-center { text-align: center; }
                            .text-right { text-align: right; }
                            .font-weight-bold { font-weight: bold; }
                            .font-italic { font-style: italic; }
                            .headline { font-size: 20px; }
                            .title { font-size: 16px; }
                            .subtitle-1 { font-size: 14px; }
                            .caption { font-size: 11px; }
                            .mb-2 { margin-bottom: 8px; }
                            .mb-4 { margin-bottom: 16px; }
                            .mb-6 { margin-bottom: 24px; }
                            .mt-4 { margin-top: 16px; }
                            .py-1 { padding-top: 4px; padding-bottom: 4px; }
                            .px-2 { padding-left: 8px; padding-right: 8px; }
                            .w-100 { width: 100%; }
                            .row { display: flex; flex-wrap: wrap; margin-right: -12px; margin-left: -12px; }
                            .col-6 { flex: 0 0 50%; max-width: 50%; padding: 12px; box-sizing: border-box; }
                            .teal--text.text--darken-4 { color: #004d40 !important; }
                            .primary--text { color: #1976d2 !important; }
                            .blue--text.text--darken-3 { color: #1565c0 !important; }
                            .red--text.text--darken-3 { color: #c62828 !important; }
                            .amber--text.text--darken-4 { color: #ff8f00 !important; }
                            .text-no-wrap { white-space: nowrap; }
                            @page {
                                margin: 10mm;
                                size: A4 portrait;
                            }
                            @media print {
                                body { padding: 0; }
                                .salary-slip-container { border: none; }
                            }
                        </style>
                    </head>
                    <body>
                        ${element.innerHTML}
                    </body>
                </html>
            `);
            w.document.close();
            w.focus();
            setTimeout(function() {
                w.print();
                w.close();
            }, 600);
        }
    }
};
</script>

<style scoped>
.salary-slip-container {
    font-family: 'Segoe UI', Roboto, Helvetica, Arial, sans-serif;
    color: #333333;
    max-width: 800px;
    margin: 0 auto;
    border: 1px solid #e0e0e0;
}
.salary-table {
    width: 100%;
    border-collapse: collapse;
    margin-bottom: 8px;
    font-size: 0.8rem;
}
.salary-table th, .salary-table td {
    border: 1px solid #d0d0d0;
    padding: 6px 8px;
    line-height: 1.2;
}
.salary-table th {
    font-weight: bold;
}
.salary-table td {
    color: #333333;
}
.blue-box {
    border: 1px solid #b3d7ff;
    background-color: #f0f7ff;
}
.w-100 {
    width: 100%;
}
</style>
